
import { getData, postData, putData, deleteData } from "../apiClient";

// Get Team Memberss with pagination
export const getTeamMembers = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/team-members/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Team Members with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// Get Team Members data with id
export const getTeamMember = async (id) => {
  try {
    const result = await getData(`/team-members/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Team Members data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create user ** // Updated Api Error Handle Method
export const createTeamMember = async ({ data }) => {
  try {
    const result = await postData(`/team-members/`, data, { "Content-Type": "multipart/form-data" });
    
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Team Members API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete user
export const deleteTeamMember = async ({ id }) => {
  try {
    const result = await deleteData(`/team-members/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Delete Team Members API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update user data
export const updateTeamMember = async ({id, data }) => {
  try {
    const result = await putData(`/team-members/${id}`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Team Members API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
